export interface ListItem {
  id: string;
  name: string;
}

export enum ListType {
  IP_ADDRESSES = 1,
  IPV6_RANGES = 2,
  APPLE_ADVERTISING_ID = 3,
  GOOGLE_ADVERTISING_ID = 4,
  BUNDLES_DOMAINS = 5,
  URL_ADDRESSES = 6,
  SCHAIN = 7
}